<template>
	<Common>
		<template #half>
			<div class="fa">
				<div class="t1">Your images</div>

				<img
					v-show="!isFin"
					class="loading turn"
					src="@/assets/loading.png"
					alt="" />
				<div
					v-show="!isFin"
					class="t2">
					Generating! Please Wait…
				</div>

				<!-- 展示生成的图片 -->
				<div
					v-show="isFin"
					class="imgs">
					<img
						v-for="item in imgs"
						:key="item"
						:src="item"
						alt="" />
				</div>

				<AdComponent ref="ads-result-1" :ads="adsensConfig.generate_1" />
				<!-- <AdComponent ref="ads-result-1" :ads="adsensConfig.result_1" /> -->

				<div
					v-show="!isFin"
					class="btns">
					<div class="b1 btn pointer">
						Generate New
						<img
							src="@/assets/fresh.png"
							alt="" />
					</div>
					<div class="b2 btn pointer">
						Download
						<img
							src="@/assets/dl.png"
							alt="" />
					</div>
				</div>
				<div
					v-show="isFin"
					class="btns">
					<div
						class="b1 btn2 pointer"
						@click="go('/generate')">
						Generate New
						<img
							src="@/assets/fresh2.png"
							alt="" />
					</div>
					<div
						class="b2 btn3 pointer"
						@click="downloadPics">
						Download
						<img
							src="@/assets/dl2.png"
							alt="" />
					</div>
				</div>
			</div>
		</template>
	</Common>
</template>

<script>
import mixin from './mixin'

export default {
	mixins: [mixin],
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
	.fa {
		width: 75vw;
		margin: auto;
	}
}
.fa {
	padding-bottom: rem(60);
}
.t1 {
	margin-top: rem(70);
	margin-bottom: rem(52);
	color: #fff;
	text-align: center;
	font-family: 'Bakbak One';
	font-size: rem(40);
	font-style: normal;
	font-weight: 400;
	line-height: rem(40); /* 100% */
	.t11 {
		background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-family: 'Bakbak One';
		font-size: rem(40);
		font-style: normal;
		font-weight: 400;
		line-height: rem(40);
	}
}

.in {
	img {
		width: rem(40);
		margin: 0 8px;
	}
	display: flex;
	align-items: center;
}
.loading {
	width: 40px;
	margin: rem(260) auto rem(30);
}
.t2 {
	color: #ccc;
	text-align: center;
	font-family: Roboto;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 133.333% */
	margin-bottom: rem(250);
}
.imgs {
	margin-bottom: rem(130);
	display: flex;
	justify-content: space-around;
	img {
		aspect-ratio: 3 / 4;
		width: 23%;
		border-radius: rem(20);
	}
}
.btns {
	display: flex;
	justify-content: center;
	.btn {
		justify-content: center;
		display: flex;
		align-items: center;
		padding: rem(20) rem(30);
		width: rem(300);
		height: rem(68);
		flex-shrink: 0;
		border-radius: rem(100);
		background: #303030;
		color: #999999;
		text-align: center;
		font-family: 'Bakbak One';
		font-size: rem(28);
		font-style: normal;
		font-weight: 400;
		line-height: rem(28); /* 100% */
		img {
			width: rem(32);
			margin-left: 10px;
		}
	}
	.btn2 {
		justify-content: center;
		display: flex;
		align-items: center;
		padding: rem(20) rem(30);
		width: rem(300);
		height: rem(68);
		flex-shrink: 0;
		border-radius: rem(100);
		background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
		color: #fff;
		text-align: center;
		font-family: 'Bakbak One';
		font-size: rem(28);
		font-style: normal;
		font-weight: 400;
		line-height: rem(28); /* 100% */
		img {
			width: rem(32);
			margin-left: 10px;
		}
	}
	.btn3 {
		justify-content: center;
		display: flex;
		align-items: center;
		padding: rem(20) rem(30);
		width: rem(300);
		height: rem(68);
		flex-shrink: 0;
		border-radius: rem(100);
		background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
		color: #fff;
		text-align: center;
		font-family: 'Bakbak One';
		font-size: rem(28);
		font-style: normal;
		font-weight: 400;
		line-height: rem(28); /* 100% */
		img {
			width: rem(32);
			margin-left: 10px;
		}
	}
	.b1 {
		margin-right: rem(80);
	}
}
</style>
